var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSilverwareBadge = function SvgSilverwareBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFEC92",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#1F1F1F",
    cx: 12,
    cy: 12,
    r: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.998 7.299c-.07-.4-.982-.403-1.039.022v2.777c-.026.067-.326.063-.346 0l-.173-2.79c-.07-.408-.965-.408-1.036 0-.002.052-.143 2.292-.173 2.79-.02.063-.318.067-.346 0V7.32c-.057-.427-.967-.421-1.037-.022-.017.092-.348 1.857-.348 2.533 0 1.027.6 1.762 1.49 2.057l-.278 4.683c-.016.272.222.498.519.498h1.384c.299 0 .535-.228.52-.498l-.28-4.683c.89-.295 1.491-1.028 1.491-2.057 0-.674-.33-2.44-.348-2.533zm2.579 5.62l-.325 3.64c-.026.275.214.511.517.511h1.212c.288 0 .519-.21.519-.472V7.472c0-.26-.231-.472-.52-.472-1.784 0-4.79 3.51-1.403 5.918z",
    fill: "#1F1F1F",
    fillRule: "nonzero"
  }))));
};

export default SvgSilverwareBadge;